import React from 'react';
import Reviews from '../components/Reviews';

const ReviewsPage = () => {
  return <Reviews />;
};

export default ReviewsPage;
